<template>
 <v-menu lazy class="date-picker"
    :close-on-content-click="false"
    transition="scale-transition"
    :disabled="disabled"
    v-model="menuVisible"
    :attach="attach">
    <v-layout column slot="activator">
      <div v-if="title" class="mt-2 text-xs-left" style="margin-bottom: -4px">{{title}}</div>
      <v-layout row justify-space-between>
        <v-icon :disabled="disabled">event</v-icon>
        <v-text-field style="width: 90px; flex-basis: auto;" class="ml-1"
          v-model="dateText"
          hide-details
          :disabled="disabled"
          readonly>
        </v-text-field>
      </v-layout>
    </v-layout>
    <v-date-picker class="date-picker-width-iphone5" :width="width" :value="date" :allowed-dates="allowedDates" @input="selectedDate" :locale="currentLocale" scrollable>
    </v-date-picker>
 </v-menu>
</template>

<script>
import moment from 'moment-es6'
import { mapState } from 'vuex'

export default {
  name: 'DatePicker',
  props: ['date', 'minStart', 'maxEnd', 'disabled', 'title', 'width', 'attach'],
  data () {
    return {
      menuVisible: false
    }
  },
  computed: {
    dateText () {
      return moment(this.date, 'YYYY-MM-DD').isValid() ? moment(this.date).format('DD/MM/YYYY') : this.$t('indefinite')
    },
    ...mapState({
      currentLocale: state => state.i18n.locale
    })
  },
  methods: {
    selectedDate (value) {
      this.menuVisible = false
      this.$emit('updated', value)
    },
    allowedDates (date) {
      let allowed = true
      if (this.minStart) {
        allowed = date >= this.minStart
      }
      if (allowed && this.maxEnd) {
        allowed = date <= this.maxEnd
      }
      return allowed
    }
  }
}
</script>

<style scoped>
#app .date-picker >>> .input-group {
  padding-top: 4px;
}
.date-picker-width-iphone5 {
  margin-left: -15px;
}
@media (min-width: 321px) {
    .date-picker-width-iphone5 {
      margin-left: 0px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/date/DatePicker.vue